<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.acc_code }}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{form.main.ac_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">行业类型</label>
            <span class="weui-form-preview__value">{{form.main.ac_industry}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{form.main.ac_contact}} {{ form.main.ac_tel }}
              <call-mobile :mobile="form.main.ac_tel"></call-mobile>
            </span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原代理商</label>
            <span class="weui-form-preview__value">{{form.main.acc_agentname_old}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新代理商</label>
            <span class="weui-form-preview__value">{{form.main.acc_agentname_new}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{form.main.acc_auditman}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallMobile from "@/components/button/CallMobile.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CallMobile
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/agent/agentcustchange"
    };
  }
};
</script>